module.exports = __webpack_public_path__ + "img/story-01.8f244690.png";